export default __webpack_public_path__ + "static/report-logo-8e10bf438077ba7e665e19b04bc3d742.png";